// GLOBAL app styles, this will load in all other standard styles;
// import { css } from 'lit-element';
import { Themes } from './themes';
import { IconStyles } from './icon-styles';

export class AppStyles {
    static get styles() {
        return [Themes.getTheme(), IconStyles.styles];
    }
}
